import { SiteNav, SiteFooter } from "@/pages/LandingPage";

export default function TermsConditions() {
  return (
    <div className="min-h-screen bg-slate-50" data-testid="terms-page">
      <SiteNav />
      <main className="pt-16">
        <section className="py-20 px-6 bg-white">
          <div className="max-w-3xl mx-auto prose prose-slate prose-sm">
            <p className="text-xs tracking-[0.2em] uppercase font-semibold text-ix-red-600 mb-3 not-prose">Legal</p>
            <h1 className="text-3xl font-bold text-ix-black tracking-tight">Terms & Conditions</h1>
            <p className="text-xs text-slate-400">Last updated: April 2026</p>

            <h2 className="text-lg font-semibold text-ix-black mt-8">1. Acceptance of Terms</h2>
            <p className="text-sm text-slate-600 leading-relaxed">By accessing or using ImpactX Bridge, you agree to be bound by these Terms and Conditions. If you do not agree, please do not use the platform.</p>

            <h2 className="text-lg font-semibold text-ix-black mt-6">2. Platform Purpose</h2>
            <p className="text-sm text-slate-600 leading-relaxed">ImpactX Bridge facilitates connections between corporate CSR teams and verified grassroots NGOs. We provide tools for matchmaking, document verification, fund tracking, and compliance reporting.</p>

            <h2 className="text-lg font-semibold text-ix-black mt-6">3. User Responsibilities</h2>
            <p className="text-sm text-slate-600 leading-relaxed">Users must provide accurate information, maintain confidentiality of their account credentials, comply with applicable Indian laws, and not misuse the platform for fraudulent activities.</p>

            <h2 className="text-lg font-semibold text-ix-black mt-6">4. Verification Process</h2>
            <p className="text-sm text-slate-600 leading-relaxed">NGOs undergo a multi-stage verification process. While we strive for accuracy, ImpactX Bridge does not guarantee the completeness of verification and users should conduct their own due diligence.</p>

            <h2 className="text-lg font-semibold text-ix-black mt-6">5. Intellectual Property</h2>
            <p className="text-sm text-slate-600 leading-relaxed">All content, trademarks, and technology on the platform are property of ImpactX Bridge Pvt Ltd. Users retain ownership of their uploaded documents and data.</p>

            <h2 className="text-lg font-semibold text-ix-black mt-6">6. Limitation of Liability</h2>
            <p className="text-sm text-slate-600 leading-relaxed">ImpactX Bridge acts as a facilitator and is not liable for disputes between CSR teams and NGOs, fund mismanagement, or outcomes of partnerships formed through the platform.</p>

            <h2 className="text-lg font-semibold text-ix-black mt-6">7. Governing Law</h2>
            <p className="text-sm text-slate-600 leading-relaxed">These terms are governed by the laws of India. Any disputes shall be subject to the exclusive jurisdiction of courts in Kerala, India.</p>
          </div>
        </section>
      </main>
      <SiteFooter />
    </div>
  );
}
